import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { Box, Typography } from '@mui/material';
import React from 'react';
export const NotificationContentSectionWrapper = ({ heading, children, }) => {
    return (React.createElement(Box, { sx: {
            display: 'flex',
            flexWrap: 'wrap',
            flexDirection: 'column',
            backgroundColor: themeColors.surface.secondary,
            alignItems: 'start',
        } },
        React.createElement(Typography, { variant: 'subtitle2', sx: { p: 2, pb: 0 } }, heading),
        React.createElement(Box, { sx: { p: 2, width: '100%' } }, children)));
};
